import { useEffect, useRef, useState } from "react";

export function CreateTableForFilterHeaderDetailed({ dataHeader = [], setFilteredHeaderForDetailed }) {
  const thRefs = useRef([]);
  const [checkedState, setCheckedState] = useState({});

  useEffect(() => {
    const initialCheckedState = {};
    dataHeader.forEach((header, index) => {
      initialCheckedState[header] = localStorage.getItem(`processedDetailed${formatString(header)}`) === 'true';
    });
    setCheckedState(initialCheckedState);
  }, [dataHeader]);

  function formatString(inputString) {
    const words = inputString.split(' ');
    const formattedString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
    return formattedString;
  }

  const checkHandler = (header, checked, index) => {
    const thElement = thRefs.current[index];

    setCheckedState(prevState => ({
      ...prevState,
      [header]: checked
    }));

    setFilteredHeaderForDetailed(prevFilteredHeader => {
      let updatedFilteredHeader = [...prevFilteredHeader];

      if (checked) {
        if (!updatedFilteredHeader.some(item => item.isEqualNode(thElement))) {
          updatedFilteredHeader.push(thElement);
        }
      } else {
        updatedFilteredHeader = updatedFilteredHeader.filter(item => !item.isEqualNode(thElement));
      }

      const headerTextArray = updatedFilteredHeader.map(thElement => thElement.textContent);
      const headerText = Array.isArray(headerTextArray) ? headerTextArray : [headerTextArray];

      localStorage.setItem('processedDetailedFilteredHeader', JSON.stringify(headerText));

      return updatedFilteredHeader;
    });

    localStorage.setItem(`processedDetailed${formatString(header)}`, checked.toString());
  };

  return (
    <div className='scrollable-table'>
      <table>
        <thead>
          <tr>
            {dataHeader.map((header, index) => (
              <th key={index} ref={el => thRefs.current[index] = el}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {dataHeader.map((header, index) => (
              <td key={index}>
                <input type="checkbox"
                  checked={!checkedState[header] ?? false}
                  onChange={(e) => checkHandler(header, !e.target.checked, index)} />
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}